/* When an input is inside a closed details element, it becames unfocusable and throws an error when the input is invalid.
This function opens the details element to prevent it */
const openDetailsOnInvalidInput = ( input ) => {
    input.addEventListener( 'invalid', () => {
        input.closest( 'details' )?.setAttribute( 'open', '' );
    } );
};

export { openDetailsOnInvalidInput };